import React, {
    useState,
    Suspense,
    lazy,
} from 'react'
import * as ls from 'utils/localStorage'

import { LottieLoader } from "components/LottieLoader";
import { ResumeViewProps } from '.'
import {
    Container,
    TextContainer,
} from './ResumeViewRedesigned.styles'

// Shares the same lazy chunk as ResumeView.tsx — webpack will only download
// react-pdf once even though two pages consume it.
const ResumePdfRenderer = lazy(() =>
    import(/* webpackChunkName: "resume-pdf-renderer" */ './ResumePdfRenderer'),
)

export default function ResumeViewRedesigned(
    {
        file,
        onUpload,
        onDownload,
        externalLoading,
        name,
        ...props
    }: ResumeViewProps,
) {
    const [pagesCount, setPagesCount] = useState(0)
    const [isLoading, setLoading] = useState(!!file)

    const userAccount: { hygienistId: number, dentist?: any, hygienist?: any } = ls.get('userAccount') || {}
    const role = Number.isInteger(userAccount.hygienistId) ? 'Hygienist' : 'Dentist'

    return (
        <Container {...props}>
            {file ? (
                <Suspense fallback={null}>
                    <ResumePdfRenderer
                        file={file}
                        pageCount={pagesCount}
                        variant='redesigned'
                        onLoadSuccess={({ numPages }) => {
                            setPagesCount(numPages)
                            setLoading(false)
                        }}
                        error={
                            role === 'Dentist'
                                ? 'Only resumes uploaded in PDF formats can be previewed here. Please download the resume to view it.'
                                : `Preview is only available for PDF files. 
                        You have a resume uploaded, but it's just in a file format that can't be previewed here. 
                        If you want to upload a new resume, click "Update Resume" below.`
                        }
                        onSourceError={() => setLoading(false)}
                        onLoadError={(err: any) => {
                            console.log(err)
                            return setLoading(false)
                        }}
                    />
                </Suspense>
            ) : (
                <TextContainer>
                    Please upload a resume to be able to submit an application to jobs.
                    Resumes need to be uploaded in one of the following formats: JPG, PNG,
                    PDF, TIFF or Word Documents.
                </TextContainer>
            )}
            <LottieLoader show={isLoading || (externalLoading as boolean)} />
        </Container>
    )
}
